import { makeStyles } from "@inductiveautomation/ws-components";

export const getConfirmationStyles = makeStyles()((theme) => ({
  helperContainer: {
    ...(theme.typography.body3 as React.CSSProperties),
    color: theme.palette.neutral[80],

    display: "flex",
    flexDirection: "row",

    [theme.breakpoints.down(768)]: {
      justifyContent: "center",
    },
  },
  helperText: {
    paddingTop: "0.075rem",
  },
  headingWithSpinner: {
    display: "inline-flex",
    alignItems: "center",
    gap: "1rem",
  },
}));
